import React, { useState, useEffect } from 'react';
import LoginForm from '../Components/LoginForm';
import RegisterForm from '../Components/RegisterForm';
import VerifyEmailForm from '../Components/verifyEmailForm';
import OlvidasteContrasenia from '../Components/olvidasteContrasenia';
import './login.css';

const Login = () => {
  const [activeTab, setActiveTab] = useState('login');
  const handleTabChange = (tab) => {
    console.log('Cambiando pestania a:', tab);
    setActiveTab(tab);
  };
  return (
    <div className="main-container-loggin">
          <div className="form-lyr-container">
            <div className="change">
              {activeTab === 'login' && <LoginForm handleTabChange={handleTabChange} />}
              {activeTab === 'register' && <RegisterForm handleTabChange={handleTabChange} />}
              {activeTab === 'verifyEmail' && <VerifyEmailForm handleTabChange={handleTabChange} />}
              {activeTab === 'olvidasteContrasenia' && <OlvidasteContrasenia handleTabChange={handleTabChange} />}
            </div>
          </div>
      </div>
  );
};

export default Login;
